/** Page Builder block definitions and defaults. */

export const BLOCK_TYPES = [
  { type: "hero", label: "Hero Banner", icon: "🌆" },
  { type: "text", label: "Metin", icon: "📝" },
  { type: "two-column", label: "İki Sütun", icon: "▤" },
  { type: "image", label: "Görsel", icon: "🖼" },
  { type: "gallery", label: "Galeri", icon: "▦" },
  { type: "stats", label: "İstatistikler", icon: "#" },
  { type: "cta", label: "Çağrı (CTA)", icon: "➜" },
  { type: "cards", label: "Kartlar", icon: "◫" },
  { type: "faq", label: "SSS", icon: "?" },
  { type: "html", label: "Özel HTML", icon: "</>" },
];

export const defaultProps = (type) => {
  switch (type) {
    case "hero":
      return {
        eyebrow: { tr: "Başlık üstü", en: "Kicker", ar: "" },
        title: { tr: "Başlık", en: "Title", ar: "" },
        subtitle: { tr: "", en: "", ar: "" },
        image: "",
        cta_label: { tr: "Devamı", en: "Learn more", ar: "" },
        cta_url: "/",
      };
    case "text":
      return {
        heading: { tr: "", en: "", ar: "" },
        body: { tr: "", en: "", ar: "" },
      };
    case "two-column":
      return {
        left: { tr: "", en: "", ar: "" },
        right: { tr: "", en: "", ar: "" },
      };
    case "image":
      return { image: "", caption: { tr: "", en: "", ar: "" } };
    case "gallery":
      return { images: [] };
    case "stats":
      return {
        items: [
          { value: "40+", label: { tr: "Yıl", en: "Years", ar: "" } },
          { value: "250+", label: { tr: "Proje", en: "Projects", ar: "" } },
        ],
      };
    case "cta":
      return {
        title: { tr: "", en: "", ar: "" },
        body: { tr: "", en: "", ar: "" },
        button_label: { tr: "İletişim", en: "Contact", ar: "" },
        button_url: "/contact",
        dark: true,
      };
    case "cards":
      return {
        items: [
          { title: { tr: "Kart", en: "Card", ar: "" }, body: { tr: "", en: "", ar: "" }, image: "" },
        ],
      };
    case "faq":
      return {
        items: [
          { q: { tr: "Soru", en: "Question", ar: "" }, a: { tr: "Yanıt", en: "Answer", ar: "" } },
        ],
      };
    case "html":
      return { html: "" };
    default:
      return {};
  }
};
